import { useApiData } from '@/hooks/useApiData';

const DEFAULT_LOGO = '/logo.jpg';
const NO_PHOTOS = {};

export function useSiteLogo() {
  const { data } = useApiData('/api/site-photos', NO_PHOTOS);
  return data.logo?.url || DEFAULT_LOGO;
}
